const url = process.env.REACT_APP_API_URL;
const camera_url = process.env.REACT_APP_CAMERA_URL;
const withUrl = (path) => `${url}${path}`;
const withCameraUrl = (path) => `${camera_url}${path}`;

// Birdhouse
export const get_birdhouses = withUrl("birdhouse");
export const get_birdhouse = (id, filter) => withUrl(`birdhouse/${id}?measurement_filter=${filter}`);
export const get_filters = withUrl("birdhouse/measurement_filters/");

// Sensor Type
export const get_sensor_type = withUrl("sensor_type/");
export const get_sensor_types_by_birdhouse_id = (id) => withUrl(`sensor_type/by_birdhouse_id/${id}`)

// Camera
export const get_camera_stream = (birdhouseId, cameraId) => withCameraUrl(`${birdhouseId}/${cameraId}/index.m3u8`);
